import store from '@/store'

export function currentUserInfo() {
  try {
    const u = (store.state && store.state.user) || {}
    if (u.id || u.username) return { id: u.id, username: u.username, name: u.name }
  } catch (e) {}
  return {}
}

export function defaultHandlerId(handlerItems) {
  const u = currentUserInfo()
  const list = handlerItems || []
  if (!list.length) return undefined
  if (u.id != null) {
    const hit = list.find((h) => String(h.id) === String(u.id))
    if (hit) return hit.id
  }
  if (u.username) {
    const hit = list.find((h) => h.username === u.username || h.name === u.username)
    if (hit) return hit.id
  }
  if (u.name) {
    const hit = list.find((h) => h.name === u.name || h.username === u.name)
    if (hit) return hit.id
  }
  return undefined
}

export function defaultWarehouseId(warehouseItems) {
  const list = warehouseItems || []
  const exact = list.find((w) => w.name === '古上仓库')
  if (exact) return exact.id
  const fuzzy = list.find((w) => String(w.name || '').indexOf('古上') !== -1)
  return fuzzy ? fuzzy.id : undefined
}

export function applyFormDefaults(form, extras = {}) {
  if (!form) return form
  const handlerItems = extras.handlerItems
  const warehouseItems = extras.warehouseItems
  const warehouseKey = extras.warehouseKey || 'warehouse'
  if ((form.handler == null || form.handler === '') && handlerItems && handlerItems.length) {
    const hid = defaultHandlerId(handlerItems)
    if (hid != null) form.handler = hid
  }
  if (warehouseItems && warehouseItems.length && (form[warehouseKey] == null || form[warehouseKey] === '')) {
    const wid = defaultWarehouseId(warehouseItems)
    if (wid != null) form[warehouseKey] = wid
  }
  return form
}
